/** How many tiers to show on each side of the current level in a projection table. */
export const PROJECTION_WINDOW_SPAN = 5

/**
 * True when a projection row's level falls inside the display window around the
 * player's current level — {@link PROJECTION_WINDOW_SPAN} tiers before and after.
 *
 * Buildings/defences are NOT capped (they climb to HQ+2, HQ unbounded), so a full
 * 1..N table would be mostly unreachable noise. The window keeps the "plan ahead"
 * table focused on where the player actually is: recent past levels for context,
 * the road ahead for planning — and it follows the player up as they level.
 * Naturally clamps near level 1 (the payload starts at level 1).
 */
export function isInProjectionWindow(
  level: number,
  currentLevel: number,
  span = PROJECTION_WINDOW_SPAN,
): boolean {
  return level >= currentLevel - span && level <= currentLevel + span
}
